import React, { useEffect, useState } from 'react';
import i18next from 'i18next';
import { Tabs, Tab, Container, Typography, Box } from '@mui/material';

import SubscriptionChoice from './Billing/Subscription';
import AddCredits from './Billing/AddCredits';
import History from './Billing/History';

const t = (i18nKey, params) => i18next.t(`userDashboard.billing.${i18nKey}`, params);

const Billing = () => {
    const [activeTab, setActiveTab] = useState('subscriptionChoice');

    const tabs = ['subscriptionChoice', 'addCredits', 'history'];

    useEffect(() => {
        const tabParam = new URLSearchParams(window.location.search).get('tab');
        if (tabParam && tabs.includes(tabParam)) setActiveTab(tabParam);
    }, []);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const renderContent = () => {
        switch (activeTab) {
            case 'subscriptionChoice':
                return <SubscriptionChoice />;
            case 'addCredits':
                return <AddCredits />;
            case 'history':
                return <History />;
            default:
                return <SubscriptionChoice />;
        }
    };

    return (
        <section id="company_dashboard" className='home'>
            <Container>
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                >
                    <Tab label={t('tabs.formula_choice')} value="subscriptionChoice" />
                    <Tab label={t('tabs.add_credits')} value="addCredits" />
                    <Tab label={t('tabs.history')} value="history" />
                </Tabs>
                <Box mt={3}>
                    {renderContent()}
                </Box>
            </Container>
        </section>
    );
};

export default Billing;